const parseJsonString = (value: string): unknown => {
  let current: unknown = value;

  while (typeof current === "string") {
    const trimmedValue = current.trim();

    if (!trimmedValue) {
      return current;
    }

    const looksLikeJson =
      (trimmedValue.startsWith("{") && trimmedValue.endsWith("}")) ||
      (trimmedValue.startsWith("[") && trimmedValue.endsWith("]")) ||
      (trimmedValue.startsWith('"{') && trimmedValue.endsWith('}"')) ||
      (trimmedValue.startsWith('"[') && trimmedValue.endsWith(']"'));

    if (!looksLikeJson) {
      return current;
    }

    try {
      current = JSON.parse(current);
    } catch {
      return current;
    }
  }

  return current;
};

const parseEmbeddedJsonString = (value: string): unknown => {
  const jsonStartIndex = value.indexOf("{");

  if (jsonStartIndex === -1) {
    return value;
  }

  const prefix = value.slice(0, jsonStartIndex).trim();
  const jsonCandidate = value.slice(jsonStartIndex).trim();

  if (!jsonCandidate.endsWith("}")) {
    return value;
  }

  try {
    const parsedValue = parseJsonString(jsonCandidate);

    if (typeof parsedValue === "string") {
      return value;
    }

    if (!prefix) {
      return parsedValue;
    }

    return {
      message: prefix,
      details: parsedValue,
    };
  } catch {
    return value;
  }
};

export const normalizeJsonContent = (value: unknown): unknown => {
  if (typeof value === "string") {
    const parsedValue = parseJsonString(value);

    if (typeof parsedValue !== "string") {
      return normalizeJsonContent(parsedValue);
    }

    return parseEmbeddedJsonString(parsedValue);
  }

  if (Array.isArray(value)) {
    return value.map((item) => normalizeJsonContent(item));
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, nestedValue]) => [key, normalizeJsonContent(nestedValue)]),
    );
  }

  return value;
};

export const formatJsonContent = (value: unknown) => {
  const normalizedValue = normalizeJsonContent(value);

  if (typeof normalizedValue === "string") {
    return normalizedValue;
  }

  return JSON.stringify(normalizedValue, null, 2);
};
